module.exports = __webpack_public_path__ + "media/images/arrow-1c514c69696049b0caa80f87e19e23ad.svg";